/* eslint-disable no-unused-expressions */
import {collision} from './collision';

export class Block {
	constructor(game) {
		this.game = game;
		this.images = document.querySelectorAll('.game__blocks');
		this.imageScale = 3;
		this.image;
		this.width;
		this.height;
		this.maxY;
		this.minY;
		this.x = this.setStartXposition();
		this.y;
		this.collisiion = false;
		this.stop = false;
		this.counted = false;
		this.cost = 1;

		// для нахождения скорости
		this.surface = {
			ground2: null,
			river: null,
		};

		this.speed;
		this.setStartXposition();
		this.setStartParams();
	}

	setSurfaceSize(area) {
		return {
			top: this.game[area].y - this.height,
			bottom: this.game.ground2.y + this.game[area].height - this.height,
		};
	}

	checkBeingOnTheSurface(area) {
		return !!(this.y > this.surface[area].top && this.y < this.surface[area].bottom);
	}

	setSpeed() {
		if (this.checkBeingOnTheSurface('ground2')) {
			return this.game.ground2.speed;
		} else if (this.checkBeingOnTheSurface('river')) {
			return this.game.river.speed;
		}

		return this.game.speed;
	}

	setMaxY() {
		return this.game.ground2.y - this.height;
	}

	setMinY() {
		return this.game.height - this.height - this.game.groundMargin / 2;
	}

	setImageParams() {
		const indexImg = Math.floor(Math.random() * this.images.length);

		this.image = this.images[indexImg];
		this.width = this.image.width / this.imageScale;
		this.height = this.image.height / this.imageScale;
	}

	setStartXposition() {
		return this.game.width + (this.game.blockStep += this.game.width / 3);
	}

	setStartYposition() {
		return Math.round(this.minY - Math.random() * (this.minY - this.maxY));
	}

	setStartParams() {
		this.setImageParams();
		this.maxY = this.setMaxY();
		this.minY = this.setMinY();
		this.y = this.setStartYposition();
		this.surface = {
			ground2: this.setSurfaceSize('ground2'),
			river: this.setSurfaceSize('river'),
		};
		this.speed = this.setSpeed();
	}

	update(player) {
		if (collision(player, this) && !this.collisiion) {
			this.collisiion = true;
			this.game.updateScore(this.cost);
		}

		if (!this.stop) {
			this.x -= this.speed;
		}

		if (this.x + this.width <= 0) {
			if (!this.counted) {
				this.game.currentBlocks++;
				this.counted = true;
			}

			if (!this.game.showNewBlocks) {
				this.stop = true;
			} else {
				if (this.stop) {
					this.stop = false;
					this.x = this.setStartXposition();
				} else {
					this.x = this.game.width;
				}

				this.counted = false;
				this.collisiion = false;

				this.setStartParams();
			}
		}
	}

	draw() {
		if (!this.collisiion) {
			this.game.ctx.drawImage(this.image, this.x, this.y, this.width, this.height);

			// debug hit box
			// context.strokeStyle = 'green';
			// context.strokeRect(this.x, this.y, this.width, this.height);
		}
	}

	resize() {
		this.maxY = this.setMaxY();
		this.minY = this.setMinY();
		this.y = this.setStartYposition();
		this.surface = {
			ground2: this.setSurfaceSize('ground2'),
			river: this.setSurfaceSize('river'),
		};
		this.speed = this.setSpeed();
	}
}
